module.exports = __webpack_public_path__ + "img/suika ibuki_sc1.6dfbf3d5.png";